module.exports = __webpack_public_path__ + "img/cuhkexpo_2017.05a15317.jpeg";